import api from '~api'
import { convertAppointmentAvailableTimeSlots, convertCareerCounsellingResponse, convertPages } from '~utils/api'

export const careerCounselorUrl = `/career-`
export const industryMentorUrl = `/workplace-`

export async function getCareerCounselors (params) {
  const {
    data
  } = await api.get(`${careerCounselorUrl}mentor`, {
    params
  })

  const counselors = data.data.map((counselor) => {
    return {
      available_appointment_time_slots: convertAppointmentAvailableTimeSlots(counselor.careerResidents),
      counselling_notice: counselor.careerResidents,
      counselling_type: 'career-counselors',
      ...convertCareerCounsellingResponse(counselor)
    }
  })

  const pages = convertPages(data.meta)

  return {
    counselors,
    pages
  }
}

export async function getCareerCounselorById (id) {
  const {
    data
  } = await api.get(`${careerCounselorUrl}mentor/${id}`)

  const counselor = data.data

  return {
    available_appointment_time_slots: convertAppointmentAvailableTimeSlots(counselor.careerResidents),
    counselor_work_experience: counselor.experience,
    counselling_notice: counselor.careerResidents,
    counselor_summary_of_qualification: counselor.expertise,
    counselling_type: 'career-counselors',
    ...convertCareerCounsellingResponse(counselor)
  }
}

export async function getIndustryMentors (params) {
  const {
    data
  } = await api.get(`${industryMentorUrl}mentor`, {
    params
  })

  const mentors = data.data.map((counselor) => {
    return {
      available_appointment_time_slots: convertAppointmentAvailableTimeSlots(counselor.workplaceResidents),
      counselling_notice: counselor.workplaceResidents,
      counselling_type: 'industry-mentors',
      ...convertCareerCounsellingResponse(counselor)
    }
  })

  const pages = convertPages(data.meta)

  return {
    mentors,
    pages
  }
}

export async function getIndustryMentorById (id) {
  const {
    data
  } = await api.get(`${industryMentorUrl}mentor/${id}`)

  const counselor = data.data

  return {
    available_appointment_time_slots: convertAppointmentAvailableTimeSlots(counselor.workplaceResidents),
    counselor_work_experience: counselor.experience,
    counselling_notice: counselor.workplaceResidents,
    counselor_summary_of_qualification: counselor.expertise,
    counselling_type: 'industry-mentors',
    ...convertCareerCounsellingResponse(counselor)
  }
}

export async function getCareerCounselorSupportServiceItems () {
  const {
    data
  } = await api.get(`${careerCounselorUrl}item`)

  const services = data.data.map((service) => {
    return {
      counselling_service_id: service.id,
      counselling_service_name: service.name
    }
  })

  return services
}

export async function getIndustryMentorSupportServiceItems () {
  const {
    data
  } = await api.get(`${industryMentorUrl}item`)

  const services = data.data.map((service) => {
    return {
      counselling_service_id: service.id,
      counselling_service_name: service.name
    }
  })

  return services
}

export async function getAllMentorWithSameGroupById (career, id) {
  const {
    data
  } = await api.get(`group/${career}/${id}`)
  return data
}
